import React from 'react';
import { useAtomValue } from 'jotai';
import MyButton from '../../../components/MyButton';
import { deletingCancellationReasonLoadingAtom } from '../../../atoms/cancellationReasonsAtoms';

function DeleteCancellationReasonModal({ reasonName, onDelete, onClose }) {
  const deletingLoading = useAtomValue(deletingCancellationReasonLoadingAtom);

  return (
    <div className="modal_wrapper">
      <div className="modal_content">
        <p className="modal_title">Удалить причину отмены?</p>
        <p className="modal_descr">
          {reasonName ? `Вы уверены, что хотите удалить причину «${reasonName}»?` : 'Вы уверены, что хотите удалить эту причину отмены?'}
        </p>
      </div>
      <div className="modal_buttons_row">
        <MyButton text="Отмена" secondary onClick={onClose} disabled={deletingLoading} />
        <MyButton text="Удалить" onClick={onDelete} loading={deletingLoading} />
      </div>
    </div>
  );
}

export default DeleteCancellationReasonModal;
